export default __webpack_public_path__ + "static/media/2006.42f2160e.png";